















































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import MeasurementRoomCard from '@/modules/measurements/components/MeasurementRoomCard.vue';
import Card from '@/components/default/Card.vue';
import Popup from '@/components/default/Popup.vue';
import { DxSwitch } from 'devextreme-vue/switch';
import { DxTabs, DxList } from 'devextreme-vue';
import { DxTreeList, DxEditing, DxRowDragging, DxColumnFixing, DxStateStoring } from 'devextreme-vue/tree-list';
import { DxTextArea } from 'devextreme-vue/text-area';
import {
  MeasurementsClient,
  IMeasurementDto,
  IUpdateMeasurementCommand,
  UpdateMeasurementCommand,
  ProjectsClient,
  MeasurementStatus,
  MeasurementRoom,
} from '@/data/web-api-client';
import notificationService from '@/services/notificationService';
import MeasurementRoomChangeNamePopup from '@/modules/measurements/components/MeasurementRoomChangeNamePopup.vue';
import MeasurementAddRoomPopup from '@/modules/measurements/components/MeasurementAddRoomPopup.vue';
import MeasurementDocument from '@/modules/measurements/components/MeasurementDocument.vue';
import MeasurementsSummary from '@/modules/measurements/components/MeasurementsSummary.vue';
import MeasurementStartPopup from '@/modules/measurements/components/MeasurementStartPopup.vue';
import MeasurementFinishedPopup from '@/modules/measurements/components/MeasurementFinishedPopup.vue';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import { EventLogsObjectType } from '@/modules/shared/eventlogs/enums';
import EventLogsTable from '@/modules/shared/eventlogs/components/EventLogsTable.vue';
import CalculateSummaryService from '../services/CalculateSummaryService';

Component.registerHooks(['beforeRouteLeave']);

@Component({
  components: {
    MeasurementRoomCard,
    Card,
    MeasurementFinishedPopup,
    MeasurementAddRoomPopup,
    Popup,
    DxSwitch,
    DxTabs,
    DxTextArea,
    MeasurementRoomChangeNamePopup,
    MeasurementDocument,
    MeasurementsSummary,
    MeasurementStartPopup,
    DxTreeList,
    DxEditing,
    DxRowDragging,
    DxColumnFixing,
    DxStateStoring,
    DxList,
    EventLogsTable,
  },
})
export default class MeasurementDetailPage extends Vue {
  loading: boolean = true;
  initialised: boolean = false;
  saving: boolean = false;
  dirty: boolean = false;
  autoInsert: boolean = true;
  onlyUseProjectCodes: boolean = true;
  leftPositionBottomBar: number = 0;
  navIndex: number = 0;
  previousArticleId: string = '';
  parentRecordId: string | null = null;
  showRearrangePopup: boolean = false;
  expectedDurationInHours: number = 0;
  data: IMeasurementDto = {
    name: '',
    projectId: '',
    projectName: '',
    recorder: '',
    status: 0,
    documentNumber: '',
    date: undefined,
    projectType: '',
    workType: '',
    rooms: [],
    notes: '',
    externalNotes: '',
  };
  measurementsClient: MeasurementsClient = new MeasurementsClient(undefined, this.$axios);
  projectCodes: string[] = [];
  disabled = false;

  debounceSave: any = debounce(async () => {
    // this.save();
  }, 5000);

  created() {
    this.loadProjectCodes();
    if (!this.checkForMeasurementInStorage()) {
      this.loadData();
    }

    try {
      const autoInsertFromStorage = localStorage.getItem('measurement.autoinsert');
      if (autoInsertFromStorage && autoInsertFromStorage === 'false') {
        this.autoInsert = false;
      }
    } catch {
      // Do nothing
    }
  }

  measurementFinished() {
    this.data.status = MeasurementStatus.Closed;
    this.save();
    (this.$refs.MeasurementFinishedPopup as MeasurementFinishedPopup).open();
  }

  addRoom(name: string) {
    this.data.rooms!.push(
      new MeasurementRoom({
        name,
        usedArticles: [],
      })
    );
  }

  openAddRoomDialog() {
    (this.$refs.MeasurementAddRoomPopup as MeasurementAddRoomPopup).open();
  }

  openChangeNameDialog(index: number, name: string) {
    (this.$refs.MeasurementRoomChangeNamePopup as MeasurementRoomChangeNamePopup).open(index, name);
  }

  updateRoomName(e: { index: number; name: string }) {
    this.data.rooms![e.index].name = e.name;
  }

  removeRoom(index: number) {
    if (confirm(`Bent u zeker dat u kamer '${this.data.rooms![index].name}' wilt wissen?`)) {
      this.data.rooms!.splice(index, 1);
    }
  }

  mounted() {
    if (document) {
      const bar = document.getElementById('savebar');

      if (bar) {
        const rect = bar.getBoundingClientRect();
        this.leftPositionBottomBar -= rect.left;
      }
    }
  }

  calculateTotalHours() {
    if (this.data.rooms) {
      var res = CalculateSummaryService.summary(this.data, this.articles, this.rawmaterials);
      this.expectedDurationInHours = Math.round((res.expectedDurationInMinutes / 60) * 100) / 100;
      this.save();
    }
  }

  get articles() {
    return this.$store.getters['articles/items'];
  }

  get rawmaterials() {
    return this.$store.getters['rawmaterials/items'];
  }

  reorderList(e: any) {
    if (!this.data.rooms) {
      return;
    }

    if (e.toIndex >= this.data.rooms.length) {
      let k = e.toIndex - this.data.rooms.length + 1;
      while (k--) {
        this.data.rooms.push(
          new MeasurementRoom({
            name: '',
            usedArticles: [],
          })
        );
      }
    }
    this.data.rooms.splice(e.toIndex, 0, this.data.rooms.splice(e.fromIndex, 1)[0]);
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    if (this.dirty) {
      if (confirm('Er zijn onopgeslagen wijzigingen. Bent u zeker dat u wenst te veranderen van pagina?')) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }

  checkForMeasurementInStorage() {
    const timestamp = localStorage.getItem('measurement.timestamp');
    const savedTimestamp = localStorage.getItem('measurement.savedTimestamp');
    const data = localStorage.getItem('measurement.data');

    if (data && timestamp && (data || data === null)) {
      if (timestamp !== savedTimestamp && data !== '') {
        const recoveredMeasurement: any = {};
        Object.assign(recoveredMeasurement, JSON.parse(data));
        if (recoveredMeasurement.documentNumber !== this.$route.params.name.replace('-', '/').replace('-', '/')) {
          // Ask to redirect
          if (confirm(`Er bevindt zich een nog onopgeslagen opmeting object van opmeting ${recoveredMeasurement.documentNumber}. Wenst u deze te herstellen?`)) {
            this.$router.push({
              path: `/projects/${recoveredMeasurement.projectId}/measurements/${recoveredMeasurement.documentNumber.replace('/', '-').replace('/', '-')}`,
            });
            location.reload();
            return true;
          }
        } else {
          // Already on correct page
          const recovered = new UpdateMeasurementCommand();
          recovered.init(recoveredMeasurement);
          this.data = recovered;
          this.save();
          this.loading = false;
          alert('Opmeting hersteld!');
          return true;
        }
      }
    }

    return false;
  }

  duplicateRoom(index: number) {
    const room = cloneDeep(this.data.rooms![index]);
    const idList: Array<{ new: string; old: string }> = [];

    room.usedArticles!.forEach((usedArticle) => {
      idList.push({ new: this.getGuid(), old: usedArticle.lineId! });
    });

    room.usedArticles!.forEach((usedArticle) => {
      const idChangeValue = idList.find((o) => o.old === usedArticle.lineId);
      usedArticle.lineId = idChangeValue ? idChangeValue.new : '';

      if (usedArticle.parentLineId && usedArticle.parentLineId !== '') {
        const idParentChangeValue = idList.find((o) => o.old === usedArticle.parentLineId);
        usedArticle.parentLineId = idParentChangeValue ? idParentChangeValue.new : '';
      }
    });

    this.data.rooms!.push(room);
  }

  async save() {
    localStorage.setItem('measurement.data', JSON.stringify(this.data));
    localStorage.setItem('measurement.timestamp', '' + Date.now());
    localStorage.setItem('measurement.savedTimestamp', '');

    const self = this;
    try {
      self.saving = true;
      const timestamp = localStorage.getItem('measurement.timestamp');
      const command: IUpdateMeasurementCommand = {
        projectId: self.projectId,
        documentNumber: self.measurementDocumentNumber,
        status: self.data.status,
        notes: self.data.notes,
        externalNotes: self.data.externalNotes,
        rooms: self.data.rooms,
        expectedDurationInHours: self.expectedDurationInHours,
        reference: self.data.reference,
      };

      const result = await self.measurementsClient.updateMeasurement(timestamp, this.projectId, new UpdateMeasurementCommand(command));

      localStorage.setItem('measurement.savedTimestamp', result);
      const storageTimestamp = localStorage.getItem('measurement.timestamp');
      self.dirty = !(storageTimestamp === result);
      this.debounceSave.cancel();
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      self.saving = false;
    }
  }

  async loadProjectCodes() {
    try {
      this.projectCodes = await new ProjectsClient(undefined, this.$axios).getUsedCodes(this.projectId);
    } catch {
      // Do nothing
    }
  }
  async loadData() {
    try {
      this.loading = true;
      const res = await this.measurementsClient.getSingle(this.projectId, this.measurementDocumentNumber.replace('/', '-').replace('/', '-'));

      if (res.rooms) {
        res.rooms.forEach((room) => {
          if (!room.usedArticles) {
            return;
          }

          console.log('MeasurementDetailPage ~ room.usedArticles.forEach ~ room.usedArticles:', room.usedArticles);
          room.usedArticles.forEach((usedArticle) => {
            if (!usedArticle.lineId || usedArticle.lineId === '') {
              usedArticle.lineId = this.getGuid();
            }
          });
        });
      }

      this.disabled = res.projectIsOnHold!;
      this.onlyUseProjectCodes = !res.isFirstMeasurement;

      Object.assign(this.data, res);
      setTimeout(() => {
        this.initialised = true;
        this.dirty = false;
        this.calculateTotalHours();
      }, 200);
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.loading = false;
    }
  }

  getGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      // tslint:disable-next-line
      const r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  setDirty() {
    this.dirty = true;
  }

  replaceCode(e: { oldArticleId: string; newArticleId: string }) {
    this.data.rooms!.forEach((room) => {
      room.usedArticles!.forEach((usedArticle) => {
        if (usedArticle.articleId === e.oldArticleId) {
          usedArticle.articleId = e.newArticleId;
        }
      });
    });

    this.projectCodes.push(e.newArticleId);
  }

  addProjectCode(e: string) {
    if (this.projectCodes.indexOf(e) === -1) {
      this.projectCodes.push(e);
    }
  }

  get navbarItems() {
    return [
      { icon: 'fas fa-info-circle', text: 'Basis info' },
      { icon: 'fas fa-info-circle', text: 'Samenvatting' },
      { icon: 'fas fa-file-pdf', text: 'Document' },
      { icon: 'fas fa-history', text: 'Geschiedenis' },
    ];
  }

  get projectId(): string {
    return this.$route.params.id;
  }

  get measurementDocumentNumber(): string {
    return this.$route.params.name.replace('-', '/').replace('-', '/');
  }

  get title() {
    return this.loading ? 'Laden...' : `${this.data.name} - ${this.data.projectName}`;
  }

  get historyConfig(): IEventLogQuery {
    return {
      objectId: this.$route.params.id,
      type: EventLogsObjectType.Measurement,
    };
  }

  get allowedArticles() {
    const articles = this.$store.getters['articles/items'];
    if (!this.onlyUseProjectCodes) {
      return articles.filter((article: any) => article.status === 0);
    }

    const codes: any[] = [];
    this.projectCodes.forEach((projectCode: string) => {
      const code = articles.find((o: any) => o.id === projectCode);
      if (code) {
        codes.push(code);
      }
    });

    return codes;
  }

  @Watch('data', { deep: true })
  onDataChanged() {
    if (this.initialised) {
      this.setDirty();
      this.debounceSave();
    }
  }

  @Watch('autoInsert')
  autoInsertChanged(value: boolean) {
    localStorage.setItem('measurement.autoinsert', '' + this.autoInsert);
  }
}
